var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hidePages
    ? _c(
        "div",
        { staticClass: "padding-right-20 flex-1 padding-y-10 flex-between" },
        [
          _c(
            "div",
            { staticClass: "flex-1 padding-right-10" },
            [_vm._t("statistics")],
            2
          ),
          _vm.asyncPage.total > 0
            ? _c(
                "el-pagination",
                _vm._b(
                  {
                    attrs: {
                      total: _vm.asyncPage.total,
                      "page-size": _vm.asyncPage.pageSize,
                      "current-page": _vm.asyncPage.current,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                      "update:pageSize": function ($event) {
                        return _vm.$set(_vm.asyncPage, "pageSize", $event)
                      },
                      "update:page-size": function ($event) {
                        return _vm.$set(_vm.asyncPage, "pageSize", $event)
                      },
                      "update:currentPage": function ($event) {
                        return _vm.$set(_vm.asyncPage, "current", $event)
                      },
                      "update:current-page": function ($event) {
                        return _vm.$set(_vm.asyncPage, "current", $event)
                      },
                    },
                  },
                  "el-pagination",
                  _vm.syncPage,
                  false
                )
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }